import { ReputationCalculationModeEnum } from "../types";

export default abstract class ReputationCalculationMode {
  abstract type: ReputationCalculationModeEnum
}
